import { render, staticRenderFns } from "./TransitRequest.vue?vue&type=template&id=fa443774&scoped=true"
import script from "./TransitRequest.vue?vue&type=script&lang=ts"
export * from "./TransitRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa443774",
  null
  
)

export default component.exports